import { X, School, MapPin, Building, Users, Shield, Zap } from "lucide-react";
import "./InfoPopup.css";

const InfoPopup = ({ isOpen, setIsOpen }) => {
  const schoolData = {
    name: "शाळा माहिती",
    subtitle: "३ — उपलब्ध",
    schools: [
      {
        id: 1,
        name: "विद्या विकास प्रशाळा टाकरी",
        principal: "श्री. साळुंखे सर",
        studentCount: 420,
        teacherCount: 9,
      },
      {
        id: 2,
        name: "उच्च माध्यमिक शाळा",
        principal: "श्रीमती पाटील",
        studentCount: 220,
        teacherCount: 12,
      },
    ],
    publicFacilities: {
      title: "सार्वजनिक सुविधा",
      facilities: [
        { icon: "📺", name: "अधिकारी संस्था", count: 10 },
        { icon: "📍", name: "ठाणे", count: 1 },
        { icon: "🏛️", name: "बँक", count: 2 },
        { icon: "🏫", name: "महाविद्यालय / विद्यापीठ", count: 1 },
        { icon: "🛡️", name: "हॉस्पिटल", count: 3 },
        { icon: "⚡", name: "वीज", count: 4 },
      ],
    },
  };

  const openPopup = () => setIsOpen(true);
  const closePopup = () => setIsOpen(false);

  return (
    <>
      <div className="popup-container">
        {isOpen && (
          <div className="popup-overlay" onClick={closePopup}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
              <div className="popup-header">
                <button onClick={closePopup} className="close-button">
                  <X size={24} />
                </button>

                <div className="header-content">
                  <div className="header-icon">
                    <School size={32} />
                  </div>
                  <div className="header-text">
                    <h2>{schoolData.name}</h2>
                    <p>{schoolData.subtitle}</p>
                  </div>
                </div>
              </div>

              <div className="popup-body">
                <div className="section">
                  <div className="section-title">
                    <School className="icon" size={24} />
                    <h3>शाळांची संपूर्ण माहिती</h3>
                  </div>

                  <div className="schools-list">
                    {schoolData.schools.map((school, index) => (
                      <div key={school.id} className="school-card">
                        <div className="school-info">
                          <div className="school-details">
                            <h4>
                              {index + 1}. {school.name}
                            </h4>
                            <div className="detail-row">
                              <span className="detail-label">
                                मुख्याध्यापक:
                              </span>
                            </div>
                            <div className="detail-row">
                              <span className="detail-label">
                                विद्यार्थी संख्या:
                              </span>
                            </div>
                            <div className="detail-row">
                              <span className="detail-label">
                                शिक्षक संख्या:
                              </span>
                            </div>
                          </div>
                          <div className="school-values">
                            <div className="spacer"></div>
                            <div className="value">{school.principal}</div>
                            <div className="value">{school.studentCount}</div>
                            <div className="value">{school.teacherCount}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default InfoPopup;
